var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogistic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.647 7.167a1.9 1.9 0 0 1-1.32-.527C1.1 5.473.607 4.2.893 2.953 1.233 1.487 2.52.833 3.647.833c1.126 0 2.42.66 2.753 2.12.287 1.247-.213 2.52-1.433 3.687-.367.353-.84.527-1.32.527M1.867 3.18c-.254 1.113.486 2.1 1.153 2.733a.91.91 0 0 0 1.26 0c.667-.633 1.407-1.62 1.147-2.74-.227-.986-1.1-1.34-1.774-1.34-.68 0-1.553.354-1.786 1.347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.674 4.133a.67.67 0 0 1-.667-.666c0-.367.293-.667.667-.667h.006c.367 0 .667.3.667.667a.67.67 0 0 1-.674.666M12.327 15.167c-.473 0-.953-.174-1.327-.527-1.233-1.167-1.733-2.44-1.44-3.693.34-1.46 1.634-2.12 2.767-2.12s2.427.66 2.767 2.12c.286 1.246-.214 2.526-1.447 3.686-.367.36-.84.534-1.32.534m0-5.334c-.68 0-1.56.354-1.793 1.347-.26 1.113.486 2.107 1.153 2.74.353.34.913.34 1.273 0 .667-.633 1.414-1.62 1.154-2.733-.22-1-1.1-1.354-1.787-1.354"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.353 12.133a.67.67 0 0 1-.666-.666c0-.367.293-.667.666-.667h.007c.367 0 .667.3.667.667a.674.674 0 0 1-.674.666M8 13.167H6.213A1.81 1.81 0 0 1 4.5 11.98a1.82 1.82 0 0 1 .507-2.027l5.327-4.66c.32-.28.326-.66.233-.92a.82.82 0 0 0-.78-.54H8a.504.504 0 0 1-.5-.5c0-.273.227-.5.5-.5h1.787A1.81 1.81 0 0 1 11.5 4.02c.274.72.073 1.513-.507 2.027l-5.326 4.66a.83.83 0 0 0-.234.92c.1.26.354.54.78.54H8c.273 0 .5.226.5.5 0 .273-.227.5-.5.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 13.167H6.213A1.81 1.81 0 0 1 4.5 11.98a1.82 1.82 0 0 1 .507-2.027l5.327-4.66c.32-.28.326-.66.233-.92a.82.82 0 0 0-.78-.54H8a.504.504 0 0 1-.5-.5c0-.273.227-.5.5-.5h1.787A1.81 1.81 0 0 1 11.5 4.02c.274.72.073 1.513-.507 2.027l-5.326 4.66a.83.83 0 0 0-.234.92c.1.26.354.54.78.54H8c.273 0 .5.226.5.5 0 .273-.227.5-.5.5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogistic);
export default __webpack_public_path__ + "static/media/logistic.4de53f0dbc4181345d95db75ab1c44f5.svg";
export { ForwardRef as ReactComponent };